import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "../styles/components/Section.scss";

// Section component provides default spacing for sections on a page
const Section = ({ className, children }) => {
    if (!children) {
        return null;
    }

    return (
        <section className={classNames("section", className)}>
            {children}
        </section>
    );
};

Section.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Section;
